import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IAgendaEduLog } from './../interfaces/iagenda-edu-log';
import { environment } from './../environments/environment';
import { AccessInfo } from './../utils/access-info';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  apiBaseUrl: string = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  logAgendaEdu(log: IAgendaEduLog) {
    const accessInfo = AccessInfo.getAccessInfo();
    log = {
      ...log,
      responsibleToken: accessInfo.responsibleToken,
      studentToken: accessInfo.studentToken,
    };

    return this.http
      .post(`${this.apiBaseUrl}agendaedu/log`, log, {
        headers: {
          'Content-Type': 'application/json',
          'x-origin-project': 'AGENDAEDU',
          Authorization: `Bearer ${accessInfo.accessToken}`,
        },
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(err: any): Observable<never> {
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }
}
